import { Box, Button, Typography } from '@mui/material';
import { useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import useAuth from '@/hooks/useAuth';

import Page from './Page';

export default function Inactive() {
  const { b2cId } = useContext(TokenContext);
  const { logoutCurrentUser } = useAuth();

  const openInNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  function signOutClickHandler() {
    if (b2cId) {
      void logoutCurrentUser('InactiveAccount');
    }
  }

  return (
    <Page>
      <Box
        sx={{
          position: 'absolute',
          top: '30%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 4,
          p: 4,
          borderRadius: '5px',
          width: '60%',
          margin: 'auto',
          minHeight: 'auto%',
          padding: '20px',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          variant='h1'
          sx={{
            margin: '20px 0',
          }}
        >
          Oops! Something went wrong.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            gap: '20px',
            flexDirection: 'column',
            flexGrow: 1,
          }}
        >
          <Typography>
            Your account was disabled. To regain access to this account, please contact us.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: '10px',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          >
            <Button
              onClick={() => {
                signOutClickHandler();
              }}
              variant='secondary'
              size='large'
            >
              Go Back
            </Button>
            <Button
              onClick={() => {
                openInNewTab('https://recognition-help.arborday.org');
              }}
              variant='primary'
              size='large'
            >
              Contact Us
            </Button>
          </Box>
        </Box>
      </Box>
    </Page>
  );
}
